/**
 * @name LoadingWrapper
 * @description Componente común donde se encapsula un componente para mostrar el spinner de carga (LoadingDots)
 * @author Ricardo Guerra
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// React Promise Tracker
import { usePromiseTracker, manuallyResetPromiseCounter } from 'react-promise-tracker';

import { LoadingDots } from '@components';

const LoadingWrapper = (props) => {
  const { promiseInProgress } = usePromiseTracker({ area: props.area, delay: 0 });

  const timeoutPromise = (area) => {
    setTimeout(() => {
      manuallyResetPromiseCounter(area);
    }, 15000); // 15 seg
  };

  useEffect(() => {
    timeoutPromise(props.area);
  }, []);

  return (
    <>
      {promiseInProgress ? (
        <LoadingDots />
      ) : (
        <div style={{ width: '100%' }}>
          {props.children}
        </div>
      )}
    </>
  );
};

LoadingWrapper.propTypes = {
  // Componente de React.
  children: PropTypes.any,
  // Área donde se va a mostrar el spinner de carga (es opcional si no existe se muestra en el área por default en ContentWrapper).
  area: PropTypes.string
};

export default LoadingWrapper;